import areAiFeaturesUsed from './are-ai-features-used';

export default {
  areAiFeaturesUsed,
};
